export default "<app-sosalert></app-sosalert>";